// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__1ddKu","information_icon":"heading_information_icon__35eFi"};